export enum DocumentType {
  MAKLERVOLLMACHT = "maklervollmacht",
  EINWILLIGUNGSERKLAERUNG = "einwilligungserklaerung",
  ERSTINFORMATION = "erstinformation"
}
